import { useCanChooseRetailerPrompt } from '~/hooks/useCanChooseRetailerPrompt';

/**
 * Whether the current user may request or view translated (non-en-US) GMC content.
 * Internal (`@lily.ai`) users only for now — the same gate as the retailer prompt — because the
 * Spanish output has had no native-speaker review yet. Opening it up is this one line.
 */
export function useCanTranslateContent(): boolean {
  return useCanChooseRetailerPrompt();
}
